import {
  CustomFieldProps,
  DateFieldProps,
  DynamicField,
  DynamicForm,
  EditorFieldProps,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { InvitationDataTableComponent } from '@/components/shared/invitation-data-table/invitation-data-table.component';
import { PlanningDataTableComponent } from '@/components/shared/planning-data-table/planning-data-table.component';
import { PlanningReviewDetailsComponent } from '@/components/shared/planning-review-details/planning-review-details.component';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { MEETING_STATUS, Participant } from '@/types/meeting.types';
import { map, of } from 'rxjs';

interface IgetInspectMeetingFormObjectProps {
  store: MeetingRepository;
  status?: MEETING_STATUS;
  comMembers: Participant[];
  comOptions: SelectOption[];
  plannedDossiers: any[];
}

export const getInspectMeetingFormObject = ({
  store,
  status,
  comMembers,
  comOptions,
  plannedDossiers,
}: IgetInspectMeetingFormObjectProps): DynamicForm => {
  const comOptionsField: DynamicField<SelectFieldProps> = {
    label: 'meeting.form.com.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservableError('comId'),
    isDisabled: of(true),
    props: {
      value: store.getObservable('comSelected'),
      filterEnabled: true,
      options: comOptions,
    },
  };

  const today = new Date(new Date().setHours(0, 0, 0, 0));

  const dueDateField: DynamicField<DateFieldProps> = {
    label: 'meeting.form.dueDate.label',
    variant: FieldVariant.DATE,
    isRequired: false,
    error: store.getNestedObservableError('reunionDate'),
    isDisabled: of(true),
    props: {
      showTime: true,
      view: 'date',
      minDate: today,
      value: store.getNestedObservable<Date>('dto', 'reunionDate').pipe(map(date => (date ? new Date(date) : null))),
    },
  };

  const titleField: DynamicField<TextFieldProps> = {
    label: 'meeting.form.title.label',
    variant: FieldVariant.TEXT,
    isRequired: false,
    isDisabled: of(true),
    error: store.getNestedObservableError('emplacement'),
    props: {
      value: store.getNestedObservable<string>('dto', 'emplacement'),
    },
  };

  const generalObjectField: DynamicField<EditorFieldProps> = {
    label: 'meeting.form.general.label',
    variant: FieldVariant.EDITOR,
    isRequired: true,
    isDisabled: of(true),
    error: store.getNestedObservableError('object'),
    props: {
      height: '200px',
      value: store.getNestedObservable<string>('dto', 'object'),
    },
  };

  const invitationTableField: DynamicField<CustomFieldProps> = {
    label: 'meeting.invitation.table.title',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    error: store.getNestedObservableError('participants'),
    props: {
      component: InvitationDataTableComponent,
      injectKeys: ['createAction', 'memebers', 'isStatusPlanned'],
      members: comMembers,
      isStatusPlanned: true,
    },
  };

  const planningTableField: DynamicField<CustomFieldProps> = {
    label: 'meeting.planning.table.title',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    error:
      store.getNestedObservableError('reunionPpms') ||
      store.getNestedObservableError('reunionDacs') ||
      store.getNestedObservableError('reunionDemandes'),
    props: {
      component: PlanningDataTableComponent,
      injectKeys: ['isDisabled', 'data'],
      data: plannedDossiers,
      isDisabled: true,
    },
  };

  const planningReviewDetailsField: DynamicField<CustomFieldProps> = {
    label: 'meeting.planning.reviewDetails.label',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    props: {
      component: PlanningReviewDetailsComponent,
      injectKeys: ['planningReviewDetails'],
      planningReviewDetails: plannedDossiers,
    },
  };
  return {
    title: 'meeting.form.title',
    orientation: 'horizontal',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [comOptionsField, dueDateField],
          },
          {
            fields: [titleField],
          },
          {
            fields: [generalObjectField],
          },
          {
            fields: [planningTableField],
          },
          {
            fields: [![MEETING_STATUS.CLOTURER, MEETING_STATUS.EN_COURS].includes(status!) ? invitationTableField : planningReviewDetailsField],
          },
        ],
      },
    ],
  };
};
